var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTargetCenter = function SvgTargetCenter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M12 21.15A9.15 9.15 0 0 0 21.15 12M12 21.15c-4.958 0-9.15-4.166-9.15-9.15M12 21.15V17m-9.15-5A9.15 9.15 0 0 1 12 2.85M2.85 12H7m14.15 0A9.15 9.15 0 0 0 12 2.85M21.15 12H17m-5-9.15V7m0 10a5 5 0 0 0 5-5m-5 5c-2.71 0-5-2.276-5-5m5 5V7m-5 5a5 5 0 0 1 5-5m-5 5h10m0 0a5 5 0 0 0-5-5",
    fill: "none"
  })));
};
export default SvgTargetCenter;